// Builds the absolute url that share buttons copy to the clipboard.
// Guards against a double slash after the host and always includes a scheme.

const buildShareUrl = (host, link) => {

    const path = link.startsWith('/') ? link : `/${link}`

    if (host === 'localhost') {
        return `http://${host}:3000${path}`
    }

    return `https://${host}${path}`
}

export default buildShareUrl
